import ClientEditAddress from "./clientEditAddress.vue";
import EditPerson from "../../Common/editPerson.vue";
import {
    required,
    requiredUnless,
    minLength,
    maxLength,
    email,
    numeric,
    requiredIf
} from "vuelidate/lib/validators";
function validateCNP(value) {
    var re = /^\d{1}\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])(0[1-9]|[1-9]\d| 5[0-2]|99)\d{4}$/, //var re = /^\d{1}\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])(0[1-9]|[1-4]\d| 5[0-2]|99)\d{4}$/,
        bigSum = 0,
        rest = 0,
        ctrlDigit = 0,
        control = "279146358279",
        i = 0;
    if (re.test(value)) {
        for (i = 0; i < 12; i++) {
            bigSum += value[i] * control[i];
        }
        ctrlDigit = bigSum % 11;
        if (ctrlDigit === 10) {
            ctrlDigit = 1;
        }

        if (ctrlDigit !== parseInt(value[12], 10)) {
            return false;
        } else {
            return true;
        }
    }
    return false;
}
export default {
    name: "ClientEditPerson",
    extends: EditPerson,
    components: { ClientEditAddress },
    data() {
        return {
            inputProps: {
                id: "autosuggest__input",
                placeholder: "",
                class: "form-control",
                name: "uniqueId",
                autocomplete: "off",
                disabled: false,
                type: "number"
            }
        };
    },
    validations: {
        person: {
            UniqueId: {
                required,
                numeric,
                minLength: minLength(13),
                maxLength: maxLength(13),
                validateCNP
            },
            LastName: {
                required
            },
            FirstName: {
                required
            },
            Phone: {
                required
            },
            Email: {
                required,
                email
            },
            IdCard: {
                required
            },
            DrivingLicenseMonth: {},
            DrivingLicenseYear: {}
        },
        leasingCompany: {
            required: requiredUnless("leasingCompanyIsOptional")
        }
    },
    methods: {
        chkState: function(val) {
            const field = this.getDescendantProp(this.$v, val);
            return field.$dirty ? !field.$error : null;
        },
        validate: function() {
            this.$v.$touch();
            this.$refs.personAddress.validate();
            this.$nextTick(() => this.findFirstError());

            var valid = this.isValid && this.$refs.personAddress.validate();

            if (this.order.OrderTypeId == 1) {
                valid = valid && this.crossCheckCNPAndDrivingLicence();
            }

            return valid;
        }
    }
};
